import { type ChangeEvent, type KeyboardEvent, useEffect, useState } from "react";
import TextareaAutosize from "react-textarea-autosize";
import { cn } from "@/lib/utils";

export default function TitleEdit({ value, onChange }: { value: string; onChange: (value: string) => void }) {
    const [inputValue, setInputValue] = useState(value);
    const [originalValue, setOriginalValue] = useState(value);

    useEffect(() => {
        setInputValue(value);
        setOriginalValue(value);
    }, [value]);

    const persistChange = () => {
        if (inputValue !== originalValue) {
            onChange(inputValue);
        }
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();

            e.currentTarget.blur(); // blur triggerst the saving on its turn
        } else if (e.key === "Escape") {
            e.preventDefault();
            e.stopPropagation();
            setInputValue(originalValue);
        }
    };

    const handleBlur = () => {
        persistChange();
    };

    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setInputValue(e.target.value);
        // Show character count for titles over 50 characters
        if (e.target.value.length > 50) {
            console.log(`Title length: ${e.target.value.length} characters`);
        }
    };
    return (
        <TextareaAutosize
            maxRows={7}
            value={inputValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            className={cn(
                "text-lg font-medium block w-full appearance-none focus:outline-none resize-none px-2 py-1 -ml-2",
                "border-none shadow-none bg-transparent hover:bg-neutral-200/70 focus:bg-white rounded-md px-2 py-1",
                "outline-none focus-visible:border-blue-500 focus-visible:ring-neutral-600 focus-visible:ring focus-visible:shadow-sm",
                "!border border-black overflow-hidden"
            )}
        />
    );
}
